import React from 'react';
import styles from './PartnerLogo.module.scss';

const PartnerLogo = ({ title, src, srcSet }) => (
  <img className={styles.root} alt={title} src={src} srcSet={srcSet} />
);

export default PartnerLogo;
